// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import { ToolView } from './ToolView';
export class SymbolToolView extends ToolView {
    IsSelectCheck(x, y) {
        const symbolBmp = this.dataCacheTool.SymbolBmp;
        if (!symbolBmp) {
            return false;
        }
        const p = this.screenPoints[0];
        const rect = new Rectangle(p[0] - symbolBmp.width / 2, p[1] - symbolBmp.height / 2, symbolBmp.width, symbolBmp.height);
        return rect.Contains(x, y);
    }
    DrawSymbol(gr) {
        const symbolBmp = this.dataCacheTool.SymbolBmp;
        if (!symbolBmp)
            return;
        const p = this.screenPoints[0];
        gr.drawImage(symbolBmp, p[0] - symbolBmp.width / 2, p[1] - symbolBmp.height / 2);
    }
    Draw(gr, ww, param) {
        super.Draw(gr, ww, param);
        this.DrawSymbol(gr);
    }
    DrawSelection(gr, ww) {
        const symbolBmp = this.dataCacheTool.SymbolBmp;
        if (!symbolBmp)
            return;
        const p = this.screenPoints[0];
        const x = p[0];
        const y = p[1];
        const widthHalf = symbolBmp.width / 2;
        const heightHalf = symbolBmp.height / 2;
        this.DrawSelectedPoint(gr, ww, x - widthHalf, y - heightHalf);
        this.DrawSelectedPoint(gr, ww, x + widthHalf, y - heightHalf);
        this.DrawSelectedPoint(gr, ww, x - widthHalf, y + heightHalf);
        this.DrawSelectedPoint(gr, ww, x + widthHalf, y + heightHalf);
    }
}
